/**
 * 将 https://cdn.xatlaz.com 域名的 URL 转换为 http 版本
 * 用于减少 SSL 握手开销，加快本地渲染速度
 */
export const toHttpCdn = (url: string): string => {
  if (url.startsWith("https://cdn.xatlaz.com/")) {
    return url.replace("https://cdn.xatlaz.com/", "http://cdn.xatlaz.com/");
  }
  return url;
};
